import { render, staticRenderFns } from "./SelectContactInsuranceModal.vue?vue&type=template&id=1b3ea2ac"
import script from "./SelectContactInsuranceModal.vue?vue&type=script&lang=js"
export * from "./SelectContactInsuranceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports